import script from "./BCAttendance.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCAttendance.vue?vue&type=script&lang=ts&setup=true"

import "./BCAttendance.vue?vue&type=style&index=0&id=5cebb277&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cebb277"]])

export default __exports__